var exports = {
  "kL": "x93eb46d8--2ec93e--container",
  "Pf": "x93eb46d8--2ec93e--label",
  "Qs": "x93eb46d8--2ec93e--content",
};

module.exports = exports;
